import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "yes-no-button" }
const _hoisted_2 = { class: "title" }


export default /*#__PURE__*/_defineComponent({
  __name: 'VYesNoButton',
  props: {
    modelValue: { type: Boolean },
    label: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as { modelValue?: boolean, label?: string }







return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(props.label), 1),
    _createVNode(_component_v_btn, {
      elevation: "0",
      color: props.modelValue? 'primary': 'default',
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', true))),
      class: "mr-2"
    }, {
      default: _withCtx(() => [
        _createTextVNode("Да")
      ]),
      _: 1
    }, 8, ["color"]),
    _createVNode(_component_v_btn, {
      elevation: "0",
      color: props.modelValue? 'default': 'primary',
      onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('update:modelValue', false)))
    }, {
      default: _withCtx(() => [
        _createTextVNode("Нет")
      ]),
      _: 1
    }, 8, ["color"])
  ]))
}
}

})